(() => {
  if (window.checkpointMobileVideos) {
    window.checkpointMobileVideos(document);
    return;
  }
  const selector = 'video[data-cp-mobile-src], video.cp-lookbook-card__video, video.checkpoint-hidden-estate__video, .checkpoint-look-row__look-image video[autoplay]';
  const mobile = window.matchMedia('(max-width: 767px)');
  const states = new Map();
  const absolute = value => new URL(value, document.baseURI).href;
  const inView = video => {
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  };
  const prepare = video => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
  };
  const selectSource = video => {
    if (!video.dataset.cpMobileSrc) return;
    const source = mobile.matches ? video.dataset.cpMobileSrc : video.dataset.cpDesktopSrc;
    if (source && (!video.getAttribute('src') || absolute(video.getAttribute('src')) !== absolute(source))) {
      video.src = source;
      video.load();
    }
  };
  const play = (video, state) => {
    if (!video.isConnected || document.hidden || !inView(video) || state.userPaused) return;
    prepare(video);
    if (!video.paused || state.pending) return;
    video.preload = 'auto';
    let attempt;
    try { attempt = video.play(); } catch (_) { return; }
    if (!attempt?.then) return;
    state.pending = true;
    attempt.then(() => {
      state.pending = false;
      video.dataset.cpAutoplay = 'playing';
      if (state.fallbackControls) {
        video.controls = false;
        state.fallbackControls = false;
      }
    }, error => {
      state.pending = false;
      video.dataset.cpAutoplay = error.name === 'NotAllowedError' ? 'blocked' : 'waiting';
      if (error.name === 'NotAllowedError' && !video.controls) {
        state.fallbackControls = true;
        video.controls = true;
      }
    });
  };
  const resume = () => states.forEach((state, video) => play(video, state));
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const video = entry.target;
      const state = states.get(video);
      if (!state) continue;
      if (entry.isIntersecting) {
        state.userPaused = false;
        play(video, state);
      } else if (!video.paused) {
        state.offscreenPause = true;
        video.pause();
      }
    }
  }, { threshold: 0 }) : null;
  const setup = root => {
    root.querySelectorAll(selector).forEach(video => {
      if (states.has(video)) return;
      const state = { pending: false, fallbackControls: false, userPaused: false, offscreenPause: false };
      states.set(video, state);
      prepare(video);
      selectSource(video);
      const ready = () => play(video, state);
      ['loadedmetadata', 'loadeddata', 'canplay'].forEach(event => video.addEventListener(event, ready));
      video.addEventListener('pause', () => {
        if (state.offscreenPause) state.offscreenPause = false;
        else if (video.controls && !state.fallbackControls && inView(video)) state.userPaused = true;
      });
      video.addEventListener('playing', () => { state.pending = false; });
      observer?.observe(video);
      play(video, state);
    });
  };
  window.checkpointMobileVideos = setup;
  setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  window.addEventListener('pageshow', () => {
    states.forEach(state => { state.pending = false; state.userPaused = false; });
    resume();
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      states.forEach(state => { state.pending = false; });
      resume();
    }
  });
  document.addEventListener('touchend', resume, { passive: true });
  document.addEventListener('pointerup', resume, { passive: true });
  document.addEventListener('keydown', resume);
  window.addEventListener('scroll', resume, { passive: true });
  mobile.addEventListener('change', () => {
    states.forEach((state, video) => { state.pending = false; selectSource(video); });
    resume();
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, video) => {
      if (event.target.contains(video)) {
        observer?.unobserve(video);
        states.delete(video);
      }
    });
  });
})();
